import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import {
  CardComponent,
  CardNumber,
  CardExpiry,
  CardCVV
} from '@chargebee/chargebee-js-react-wrapper';
import PropTypes from 'prop-types';

const CBCardComponent = (props, ref) => {
  const cardRef = useRef();
  const [options] = useState({
    classes: {
      focus: 'focus',
      invalid: 'invalid',
      empty: 'empty',
      complete: 'complete'
    },
    style: {
      base: {
        color: '#2a2d5b',
        fontWeight: '500',
        fontFamily: 'filson-pro-regular, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        ':focus': {},
        '::placeholder': {
          color: '#9293AB',
          fontSize: '14px'
        },
        ':focus::placeholder': {
          color: '#666'
        },
        ':-webkit-autofill': {
          webkitTextColor: '#2a2d5b'
        }
      },
      invalid: {
        color: '#e41029',
        ':focus': {
          color: '#e44d5f'
        },
        '::placeholder': {
          color: '#FFCCA5'
        }
      }
    },
    locale: 'en'
  });

  const tokenize = (additionalData) => {
    return cardRef.current.tokenize(additionalData).then((data) => {
      return data;
    });
  };

  function getExpiry() {
    if (props.card?.cardExpiryYear) {
      return `${props.card?.cardExpiryMonth}/${props.card?.cardExpiryYear?.toString()?.slice(-2)}`;
    }
  }

  useImperativeHandle(ref, () => ({
    tokenize
  }));

  const { style, classes, locale, fonts } = options;

  return (
    <CardComponent
      ref={cardRef}
      styles={style}
      classes={classes}
      className="fieldset field"
      locale={locale}
      fonts={fonts}>
      <div className="mb-3">
        <label htmlFor="ccnumber" className="form-label filson-pro-regular font14px">
          Credit Card Number
        </label>
        <CardNumber
          placeholder={props.card?.maskedNumber}
          required
          className="form-control h40px"
        />
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-3">
            <label htmlFor="expiration" className="form-label filson-pro-regular font14px">
              Expiration
            </label>
            <CardExpiry placeholder={getExpiry()} className="form-control h40px" />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <label htmlFor="cvv" className="form-label filson-pro-regular font14px">
              CVC/CVV
            </label>
            <CardCVV className="form-control h40px" />
          </div>
        </div>
      </div>
    </CardComponent>
  );
};

CBCardComponent.propTypes = {
  card: PropTypes.object
};

export default forwardRef(CBCardComponent);
